export * as Api from './api';
export var FeeChargeType;
(function (FeeChargeType) {
    FeeChargeType["Investor"] = "investor";
    FeeChargeType["Investment"] = "investment";
})(FeeChargeType || (FeeChargeType = {}));
export var FeeExportType;
(function (FeeExportType) {
    FeeExportType["General"] = "GENERAL";
    FeeExportType["Custodian"] = "CUSTODIAN";
})(FeeExportType || (FeeExportType = {}));
export var FeeExistenceFilterType;
(function (FeeExistenceFilterType) {
    FeeExistenceFilterType["All"] = "ALL";
    FeeExistenceFilterType["Future"] = "FUTURE";
    FeeExistenceFilterType["Past"] = "PAST";
})(FeeExistenceFilterType || (FeeExistenceFilterType = {}));
//# sourceMappingURL=index.js.map